<template>
    <div class="row" v-if="failure">
        <div class="col s6 offset-s3 center-align" style="margin-top:30px">
            <h5>
                There was a problem processing your file.  We will return to you to the dashboard in a few seconds.  If this consumed one of your credits, please contact us with details and we will correct this.
            </h5>
        </div>
    </div>
    <div v-else>
        <div v-if='initing' style='height:100%;text-align:center;'>
            <h4>Loading</h4>
            <div class="preloader-wrapper small active">
                <div class="spinner-layer">
                    <div class="circle-clipper left">
                        <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                        <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <div class="startjobtitle" v-if="nestedMode">
                <div class="center-align">
                    <h5 class="bold startjob">Start Nested Job: {{nestedJobName}}</h5>
                    <h5 class="bold startjob">Choose your orientation optimization</h5>
                </div>
                <div class="center-align startjob" v-if="!subscription">
                    <p class="startjob">This job costs {{ costString }}. 1 credit for each part file to be nested.
                        <buy-credits :showModal.sync="showModal">
                            <a slot='display' slot-scope='props' @click='props.open'>Buy Subscription</a>
                        </buy-credits>
                    </p>
                </div>
            </div>
            <div class="startjobtitle" v-else>
                <div class="center-align">
                    <h5 class="bold startjob">Start Job: choose your orientation optimization</h5>
                </div>
                <div class="center-align startjob" v-if="!subscription">
                    <p class="startjob">This job costs {{ costString }}.
                        <buy-credits :showModal.sync="showModal">
                            <a slot='display' slot-scope='props' @click='props.open'>Buy Subscription</a>
                        </buy-credits>
                    </p>
                </div>
            </div>
            <div class="container" v-if="nestedMode">
                <div class="row">
                    <div class="col s12 center-align">
                        <input type="checkbox" class="filled-in" id="useForAll"
                               @change="switchPartParamAll()"
                               v-model="partParamsAll"/>
                        <label for="useForAll">Use the same parameters for all nested parts</label>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row" v-if="!partParamsAll">
                    <div class="col s12">
                        <div class="block-dots top center-align">
                            <div class="tooltip-wrp" v-for="(fileObj, index) of files" :key="fileObj.id">
                                <div class="file-dot"
                                     :class="{'selected': index === fileIndex}"
                                     @click="switchFile(index)"></div>
                                <div class="tooltip">
                                    <span class="tooltipvalue">{{fileObj.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style='display:inline-flex;'>
                    <div class="col s4 a3dlightgray" style='border-right:6px solid white;position:relative;'>
                        <div class='info-overlay' v-if='expertAdvice || files[fileIndex].optMinDist || files[fileIndex].optMaxDist'>
                            <div class='blur'></div>
                            <div class='content valign-wrapper'>
                                <h6 class="bold startjobtitle">
                                    In order to select weights, please deselect {{selectedColumn}}.</h6>
                            </div>
                        </div>
                        <h6 class="bold startjobtitle">
                            Use the experience of "Design for Additive" experts by weighing each of the following 3 factors:</h6>
                        <div class="startjobtitle">
                            <form action="#">
                                <p>Minimum Build Time</p>
                                <p class="range-field">
                                    <input type="range" id="minbuildtime" min="0" max="1" step="any"
                                           v-model.number="files[fileIndex].weights[0]" :disabled="files[fileIndex].optMinDist || loading"/>
                                </p>
                                <p>Minimum Material Consumption</p>
                                <p class="range-field">
                                    <input type="range" id="minmaterialconsumption" min="0" max="1" step="any"
                                           v-model.number="files[fileIndex].weights[1]" :disabled="files[fileIndex].optMinDist || loading"/>
                                </p>
                                <p>Minimum Support Structure Removal</p>
                                <p class="range-field">
                                    <input type="range" id="minsupportstructure" min="0" max="1" step="any"
                                           v-model.number="files[fileIndex].weights[2]" :disabled="files[fileIndex].optMinDist || loading"/>
                                </p>
                                <div class="wrapper">
                                  <p>Minimum Distortion</p>
                                  <p class="range-field">
                                      <input type="range" id="minimumdistortion" min="0" max="1" step="any"
                                            v-model.number="files[fileIndex].weights[3]" :disabled="files[fileIndex].optMinDist || loading"/>
                                  </p>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--- <div class="col s3 a3dlightgray" style='border:0 3px solid white;'>
                        <div class="startjobtitle">
                            <h6 class="bold">
                                Atlas 3D surveyed dozens of experienced additive engineers to see what factors were most important to them when orienting a part. You can use these experts’ weighting simply by checking this box.
                            </h6>
                            <form action="#">
                                <p class="startjobor">
                                    <input type="checkbox" class="filled-in" id="expertadvice" :disabled="(minDistort || maxDistFlag) || loading"
                                           v-model="expertAdvice" checked="unchecked"/>
                                    <label for="expertadvice">I prefer expert advice</label>
                                </p>
                            </form>
                        </div>
                    </div> -->
                    <div class="col s4 a3dlightgray" style='border-left:6px solid white;'>
                        <div class="startjobtitle">
                            <h6 class="bold" v-if="nestedMode">
                                Maximize part density while minimizing thermal distortion for each part.
                            </h6>
                            <h6 class="bold" v-else>
                                Use Siemens proven ability to computationally minimize thermal distortion.
                            </h6>
                            <form action="#">
                                <p class="startjobor">
                                    <input type="checkbox" class="filled-in" id="mindistortion"
                                           :disabled="(expertAdvice || files[fileIndex].optMaxDist) || loading"
                                           v-model="files[fileIndex].optMinDist" checked="unchecked"/>
                                    <label for="mindistortion">Minimal distortion is most important</label>
                                </p>
                                <p class="startjobor" v-if="files[fileIndex].optMinDist">
                                    <input type="checkbox" class="filled-in" id="isHeatTreatment"
                                           :disabled="(expertAdvice || files[fileIndex].optMaxDist) || loading"
                                           v-model="files[fileIndex].isHeatTreatment" checked="unchecked"/>
                                    <label for="isHeatTreatment">Perform "stress relief" before removing parts from the build plate</label>
                                </p>
                                <p class="startjobor" v-if="files[fileIndex].optMinDist">
                                    <input type="checkbox" class="filled-in" id="isMinPeeling"
                                           :disabled="(expertAdvice || files[fileIndex].optMaxDist) || loading"
                                           v-model="files[fileIndex].isMinPeeling" checked="unchecked"/>
                                    <label for="isMinPeeling">Minimal recoater interference is more important than overall dimensional accurary.</label>
                                </p>
                            </form>
                        </div>
                    </div>
                    <div class="col s4 a3dlightgray" style='border-left:6px solid white;'>
                        <div class="startjobtitle">
                            <h6 class="bold" v-if="nestedMode">
                                Minimize build time while controlling thermal distortion for each part.
                            </h6>
                            <h6 class="bold" v-else>
                                Use Siemens ability to find the least amount of build time within a constraint.
                            </h6>
                            <form action="#">
                                <p class="startjobor">
                                    <input type="checkbox"
                                           class="filled-in"
                                           id="maxDistFlag"
                                           v-model="files[fileIndex].optMaxDist"
                                           :disabled="(expertAdvice || files[fileIndex].optMinDist) || loading" />
                                    <label for="maxDistFlag">Set a limit on maximum thermal distortion</label>
                                </p>
                            </form>
                            <div v-if="files[fileIndex].optMaxDist">
                                <span class="title">
                                    What is the maximum thermal distortion allowable on this part? +/-
                                </span>
                                <div class="input-field inline">
                                    <input id="maxDist" type="number" min="0" step="0.1"
                                           v-model="files[fileIndex].maxDist">
                                    <label for="maxDist"></label>
                                </div>
                                <span class="title">
                                    millimeters
                                </span>
                                <div class="error" v-if="Array.isArray(validationError) && validationError[fileIndex]">
                                    {{validationError[fileIndex]}}
                                </div>
                                <p class="startjobor">
                                    <input type="checkbox" class="filled-in" id="isHeatTreatment"
                                           :disabled="(expertAdvice || files[fileIndex].optMinDist) || loading"
                                           v-model="files[fileIndex].isHeatTreatment" checked="unchecked"/>
                                    <label for="isHeatTreatment">Perform "stress relief" before removing parts from the build plate</label>
                                </p>
                                <p class="startjobor" v-if="files[fileIndex].optMinDist">
                                    <input type="checkbox" class="filled-in" id="isMinPeeling"
                                           :disabled="(expertAdvice || files[fileIndex].optMaxDist) || loading"
                                           v-model="files[fileIndex].isMinPeeling" checked="unchecked"/>
                                    <label for="isMinPeeling">Minimal recoater interference is more important than overall dimensional accurary.</label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!partParamsAll">
                    <div class="col s12">
                        <div class="block-dots bottom center-align">
                            <div class="tooltip-wrp" v-for="(fileObj, index) of files" :key="fileObj.id">
                                <div class="file-dot"
                                     :class="{'selected': index === fileIndex}"
                                     @click="switchFile(index)"></div>
                                <div class="tooltip">
                                    <span class="tooltipvalue">{{fileObj.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="row" v-if="nestedMode">
                    <div class="col s4 offset-s4 job-name">
                        <span class="bold">Name of Nested job:</span>
                        <div class="input-field inline">
                            <input id="nestedJobName" type="text" v-model="nestedJobName">
                        </div>
                        <div class="error center-align" v-if="validationError && !Array.isArray(validationError)">
                            {{validationError}}
                        </div>
                    </div>
                    <div class="col s4 offset-s4 center-align">Enter the name you would like to use to refer to this job in your dashboard</div>
                </div>-->
                <div class="row" v-if="!nestedMode">
                    <div class="a3dlightgray col s12 restrictions-block">
                        <div class="restrictions">
                            <!--<div class="restriction">
                                <input type="checkbox" class="filled-in" id="restrictOrientation" v-model="restrictOrientation" :disabled="loading" />
                                <label for="restrictOrientation">Restrict Orientation (search for optimal orientation in a specified range of orientations)</label>
                            </div>
                            <div class="restriction">
                                <input type="checkbox" class="filled-in" id="restrictFaces" v-model="restrictFaces" :disabled="loading" />
                                <label for="restrictFaces">Restrict Support Structures (restrict/allow support attachment at specified areas)</label>
                            </div>-->
                            <div class="restriction">
                                <input type="checkbox"
                                       class="filled-in"
                                       id="optimizationConstrain"
                                       v-model="optimizationConstrain"
                                       :disabled="loading || submitting" />
                                <label for="optimizationConstrain">Constrain the optimization to a range of orientations and/or specify faces of the part where supports should not be attached</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div v-if="loading && statusMessage" class="col s12 center-align status-message">
                        {{statusMessage}}
                    </div>
                    <div v-if="loading" class="progress">
                      <div class="determinate"
                           v-if="remeshingPart && remeshingProgress > 0"
                           :style="{width: remeshingProgress * 100 + '%'}">
                      </div>
                      <div class="indeterminate" v-else>
                      </div>
                    </div>
                    <div v-if="!loading">
                        <div class="col s12 center-align">
                            <a @click="validate" class="btn a3d" v-if="subscription || user.credits.length >= this.files.length">
                                <template v-if="subscription">
                                    Start job
                                </template>
                                <template v-else>
                                    Start job ({{costString}})
                                </template>
                            </a>
                            <template v-else>
                                <a @click="buymodal" class="a3d btn">Buy Subscription</a>
                                <div class="note bold">This job costs {{costString}}</div>
                            </template>
                        </div>
                        <div class="col s12 center-align note" v-if="nestedMode && !subscription">
                            1 credit for each part file to be nested.
                        </div>
                    </div>
                </div>
            </div>
            <modal ref="summarymodal" name="summarymodal" :pivotY="0.2" :reset="true" height="auto" width="75%">
                <job-summary :config="files[0].config" :jobDescription="jobDescription" :submit="submitSingle"></job-summary>
            </modal>
        </template>
    </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import BuyCredits from './BuyCredits'
  import JobSummary from './JobSummary'
  import errorHandling from '../mixins/errorHandling'

  export default {
    name: 'home',
    components: {
      'buy-credits': BuyCredits,
      JobSummary
    },
    mixins: [errorHandling],
    props: ['auth', 'authenticated'],
    data () {
      return {
        initing: true,
        loading: false,
        job: {},
        failure: false,
        expertAdvice: false,
        maxDist: 1,
        validationError: null,
        restrictOrientation: false,
        restrictFaces: false,
        optimizationConstrain: false,
        showModal: function () {},
        nestedMode: false,
        nestedJobName: null,
        partParamsAll: true,
        parentPathKey: null,
        files: [],
        fileIndex: 0,
        submitting: false,
        statusMessage: null,
        remeshingPart: null,
        remeshingProgress: null,
        jobDescription: ''
      }
    },
    methods: {
      ...mapActions({
        refreshCredits: 'user/refreshCredits'
      }),
      ...mapActions([
        // 'getJobs',
        'getNestedJobs',
        'setNestedFileData',
        'getJob',
        'updateJob',
        'updateNestedJob',
        'submitJob',
        'submitNestedJob',
        'getURLData',
        'remeshPart'
      ]),
      buymodal: function () {
        this.$modal.show('details')
      },
      validate: function () {
        this.validationError = []
        let valid = true
        this.files.forEach((file, index) => {
          if (file.optMaxDist && file.maxDist > 0 || !file.optMaxDist) {
            this.validationError[index] = null
            return
          } else {
            this.validationError[index] = 'Empty or invalid value for maximum thermal distortion'
            valid = false
            this.switchFile(index)
          }
        })
        if (this.nestedMode && valid && (!this.nestedJobName || this.nestedJobName.length < 2)) {
          valid = false
          this.validationError = 'Enter valid job name'
        }
        if (valid) {
          this.submit()
        }
      },
      submit: function () {
        this.files.forEach((file) => {
          if (file.optMinDist) {
            file.analysisId = 5
            file.objectiveId = 1
            file.config.MaxDist = [-1]
            file.config.isHeatTreatment = file.isHeatTreatment
            file.config.isMinPeeling = file.isMinPeeling
          // } else if (this.expertAdvice) {
          //   this.analysisId = 4
          //   this.objectiveId = 20
          } else if (file.optMaxDist) {
            file.analysisId = 5
            file.objectiveId = 14
            file.config.MaxDist = [parseFloat(file.maxDist)]
          } else {
            file.analysisId = 4
            file.objectiveId = 21
            file.config.MaxDist = [-1]
          }

          file.config.Weights = file.weights
        })

        if (!this.loading) {
          if (this.nestedMode) {
            this.submitNested()
          } else {
            if (this.optimizationConstrain) {
              this.submitSingle('')
            } else {
              this.openSummary()
            }
          }
        }
      },
      submitSingle: function (jobDescription) {
        this.submitting = true
        this.loading = true
        this.jobDescription = jobDescription
        const remeshSourceFile = () => {
          if (this.files[0].config.needRemesh) {
            this.statusMessage = 'Remeshing in progress...'
            this.remeshingPart = true
            return new Promise((resolve, reject) => {
              let filename
              this.remeshPart({
                sourceFilePathKey: this.files[0].sourceFilePathKey,
                config: {...this.files[0].config, AdditionalConfig: undefined, Weights: [0.5, 0.5, 0.5]}
              })
                .then((res) => {
                  filename = res.data.filename
                  this.remeshPartProgress(res.data.progress)
                  return this.remeshPartAttempt(res.data.url, 1)
                })
                .then(() => {
                  resolve(filename)
                })
                .catch((err) => {
                  if (err) {
                    console.log('Remeshing error')
                  }
                  resolve(null)
                })
            })
          } else {
          }
          return Promise.resolve()
        }
        return remeshSourceFile()
          .then((filename) => {
            if (filename) {
              this.files[0].config.filename = filename
            }
            this.remeshingPart = false
            this.statusMessage = 'Updating job...'
            return this.updateJob({
              jobPathKey: this.files[0].jobPathKey,
              config: {...this.files[0].config, needRemesh: false},
              jobDescription
            })
          })
          .then(response => {
            if (this.optimizationConstrain) {
              this.$router.push({
                name: 'ThreeJSViewer',
                params: {
                  id: this.files[0].jobPathKey,
                  type: 'input',
                  restrictOrientation: this.optimizationConstrain,
                  restrictFaces: this.restrictFaces,
                  createConfig: this.files[0].config,
                  submitJobData: {
                    jobPathKey: response.data.jobPathKey,
                    objectiveId: this.files[0].objectiveId,
                    analysisId: this.files[0].analysisId
                  }
                }})
            } else {
              return this.submitJob({
                jobPathKey: response.data.jobPathKey,
                objectiveId: this.files[0].objectiveId,
                analysisId: this.files[0].analysisId
              }).then(success => {
                this.loading = false
                this.submitting = false
                this.statusMessage = null
                this.failure = !success
                this.refreshCredits()
                // setTimeout(() => {
                this.$router.replace({name: 'Dash'})
                // }, 7000)
              })
            }
          })
          .catch((err) => {
            this.loading = false
            this.submitting = false
            this.statusMessage = null
            this.openSummary()
            this.errorHandling(err, () => {
              this.submitSingle(jobDescription)
            })
          })
      },
      submitNested: function () {
        this.loading = true
        const nestedJobsData = {
          nestedJobs: [],
          nestedJobName: this.nestedJobName,
          parentPathKey: this.parentPathKey
        }
        if (this.partParamsAll) {
          this.copyPartParamAll()
        }
        this.files.forEach((file) => {
          nestedJobsData.nestedJobs.push({
            config: {...file.config, needRemesh: false},
            jobPathKey: file.jobPathKey
          })
        })
        this.updateNestedJob(nestedJobsData).then((response) => {
          const submitJobsData = []
          this.files.forEach((file) => {
            submitJobsData.push({
              jobPathKey: file.jobPathKey,
              analysisId: file.analysisId,
              objectiveId: file.objectiveId
            })
          })
          return this.submitNestedJob(submitJobsData)
        })
          .then((response) => {
            this.refreshCredits()
            this.loading = false
            this.$store.commit('RESET_NESTED_DATA')
            this.$router.replace({name: 'Dash'})
          })
          .catch((err) => {
            this.loading = false
            this.errorHandling(err, this.submitNested)
          })
      },
      remeshPartAttempt: function (url, attempt) {
        return new Promise((resolve, reject) => {
          this.getURLData({url})
            .then((response) => {
              if (response.data) {
                if (response.data.result === true) {
                  resolve()
                } else {
                  reject({message: 'Server error'})
                }
              }
            })
            .catch((err) => {
              if (err.response &&
                err.response.status &&
                err.response.status === 404 &&
                attempt <= 42) {
                attempt++
                let delay = 1500 * attempt
                if (attempt > 15) {
                  delay = 30000
                } else if (attempt > 3) {
                  delay = 10000
                }
                setTimeout(() => {
                  resolve(this.remeshPartAttempt(url, attempt))
                }, delay)
              } else {
                reject(err)
              }
            })
        })
      },
      remeshPartProgress: function (url) {
        if (this.remeshingPart) {
          this.getURLData({url})
            .then((response) => {
              this.remeshingProgress = response.data.progress
              setTimeout(() => {
                this.remeshPartProgress(url)
              }, 2500)
            })
            .catch(() => {
              console.log('Getting remesh progress...')
              setTimeout(() => {
                this.remeshPartProgress(url)
              }, 2500)
            })
        }
      },
      openSummary: function () {
        this.$modal.show('summarymodal')
      },
      checkNestedMode: function () {
        return this.$route.name === 'NestedMagicById' || this.$route.name === 'NestedMagic'
      },
      filesPrepare: function (keys) {
        const files = []
        keys.forEach((key) => {
          files.push(
            JSON.parse(JSON.stringify(Object.assign({}, {
              config: this.filesNested[key].config,
              name: this.filesNested[key].name,
              pathKey: key,
              jobPathKey: this.filesNested[key].jobPathKey,
              analysisId: 0,
              objectiveId: 0,
              optWeights: true,
              optMinDist: false,
              optMaxDist: false,
              isHeatTreatment: true,
              isMinPeeling: false,
              weights: [0.5, 0.5, 0.5, 0.5],
              maxDist: 1
            })))
          )
        })
        return files
      },
      switchFile: function (index) {
        this.fileIndex = index
      },
      switchPartParamAll: function () {
        this.switchFile(0)
        if (!this.partParamsAll) {
          this.copyPartParamAll()
        }
      },
      copyPartParamAll: function () {
        this.files.forEach((file) => {
          file.weights[0] = this.files[0].weights[0]
          file.weights[1] = this.files[0].weights[1]
          file.weights[2] = this.files[0].weights[2]
          file.weights[3] = this.files[0].weights[3]
          file.maxDist = this.files[0].maxDist
          file.analysisId = this.files[0].analysisId
          file.objectiveId = this.files[0].objectiveId
          file.optMaxDist = this.files[0].optMaxDist
          file.optMinDist = this.files[0].optMinDist
          file.optWeights = this.files[0].optWeights
          file.isHeatTreatment = this.files[0].isHeatTreatment
          file.isMinPeeling = this.files[0].isMinPeeling
        })
      },
      getNestedJobsRestore: function () {
        return new Promise((resolve, reject) => {
          return this.getJob(this.parentPathKey)
            .then((response) => {
              if (response && response.data.Job && response.data.Job.hasOwnProperty('nestedJobName')) {
                this.nestedJobName = response.data.Job.nestedJobName
                return this.getNestedJobs(this.parentPathKey)
              } else {
                this.$router.push({name: 'Dash'})
              }
            })
            .then((response) => {
              if (response && response.data.allJobs && response.data.allJobs.length > 0) {
                this.setNestedFileData(response.data.allJobs)
                resolve(response.data.allJobs)
              } else {
                reject()
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
      },
      goBack: function () {
        this.$router.back()
      }
    },
    computed: {
      ...mapState([
        'user',
        'filesNested'
      ]),
      ...mapGetters({
        subscription: 'user/subscriptionExpiration'
      }),
      costString: function () {
        // logic later
        let credits = 1
        if (this.files.length > 0) {
          credits *= this.files.length
        }
        return credits + ' credit' + (credits > 1 ? 's' : '')
      },
      selectedColumn: function () {
        let message = ''
        if (this.expertAdvice) {
          message = '"I prefer expert advice"'
        } else if (this.files[this.fileIndex].optMinDist) {
          message = '"Minimal distortion is most important"'
        } else if (this.files[this.fileIndex].optMaxDist) {
          message = '"Set a limit on maximum thermal distortion"'
        }
        return message
      }
    },
    created () {
      this.nestedMode = this.checkNestedMode()
      if (this.nestedMode && this.$route.params.id) {
        this.parentPathKey = this.$route.params.id
        this.getNestedJobsRestore().then(() => {
          if (Object.keys(this.filesNested).length > 0) {
            this.files = this.filesPrepare(Object.keys(this.filesNested))
            this.switchFile(0)
            this.initing = false
          } else {
            this.$router.push({name: 'Dash'})
          }
        })
          .catch((err) => {
            this.errorHandling(err, this.getNestedJobsRestore)
          })
      } else {
        this.getJob(this.$route.params.jobPath).then((response) => {
          this.initing = false
          const job = response.data.Job
          this.files.push({
            config: job.config,
            jobPathKey: job.pathKey,
            sourceFilePathKey: job.sourceFile.pathKey,
            analysisId: 0,
            objectiveId: 0,
            optWeights: true,
            optMinDist: false,
            optMaxDist: false,
            weights: [0.5, 0.5, 0.5, 0.5],
            isHeatTreatment: true,
            isMinPeeling: false,
            maxDist: 1
          })
        })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.getJob(this.$route.params.jobPath)
            })
          })
      }
    }
  }
</script>

<style lang='scss' scoped>
    a {
        cursor: pointer;
    }

    .container {
        .note {
            padding: 8px 0;
        }
        input[type="checkbox"].filled-in:checked + label:after {
            border-color: #00BDD1;
            background-color: #00BDD1;
        }
        input[type="range"] {
            border: none;
        }
        input[type="range"]::-webkit-slider-thumb {
            background-color: #00BDD1;
        }
        input[type="range"]::-moz-range-thumb {
            background-color: #00BDD1;
        }
        input[type="range"]::-ms-thumb {
            background-color: #00BDD1;
        }
        label[for="useForAll"] {
            color: inherit;
        }

        .row {
            .status-message {
                font-size: 1.6rem;
            }
        }
    }

    .error {
        color: #ff0000;
    }

    .info-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        background-color: rgba(204, 204, 204, 0.9);
        > .content {
            position: absolute;
            height: 100%;
            > * {
                text-align: center;
            }
        }
    }

    .startjobtitle {
        .title {
            font-weight: bold;
            padding: 8px 0;
        }

        .note {
            padding-top: 8px;
        }

        .startjobor {
            margin-bottom: 16px;
        }

        .file-row {
            display: flex;
            flex-direction: row;
            div {
                padding: 0 4px;

                &.file-name {
                    flex: 2;
                }

                &.file-name, &.file-unit {
                    padding-top: 8px;
                }

                input {
                    min-width: 40px;
                    max-width: 60px;
                    padding: 0 4px;
                    height: 2.5rem;
                    background: #fff;
                }
            }
        }

        .input-field {
            margin: 0 4px;
            width: 100px;

            #maxDist {
                background-color: #fff;
                text-align: right;
                height: 2rem;
                margin: 0;
            }
        }
    }

    .restrictions-block {
        display: flex;
        justify-content: center;

        .restrictions {
            padding: 16px;
            display: inline-block;

            .restriction {
                padding-bottom: 12px;

                &:last-child {
                    padding-bottom: 0;
                }
            }

            label {
                padding-right: 48px;

                &:last-child {
                    padding-right: 0;
                }
            }
        }
    }

    .block-dots {
        &.top {
            padding-top: 12px;
        }

        &.bottom {
            padding-bottom: 12px;
        }

        .tooltip-wrp {
            display: inline-block;

            .tooltip {
                display: none;
                margin: 0;

                .tooltipvalue {
                    top: -52px;
                    left: 12px;
                    width: auto;
                    padding: 2px 12px;
                    transform:translateX(-50%);
                    margin-left: 0;
                }
            }

            .file-dot {
                margin: 4px;
                width: 16px;
                height: 16px;
                border: 1px solid #00BDD1;
                border-radius: 50%;
                background-color: transparent;

                &.selected, &:hover {
                    background-color: #00BDD1;
                }
            }

            .file-dot:hover + .tooltip {
                display: block;
            }
        }
    }

    .tooltip-wrp {
        position: relative;

        .tooltip {
            position: relative;

            .tooltipvalue {
                position: absolute;
                width: 40px;
                text-align: center;
                top: -20px;
                margin-left: -20px;
                background-color: #00BDD1;
                border-radius: 12px;
                color: #fff;

                &:after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -5px;
                    margin-top: -7px;
                    width: 10px;
                    height: 10px;
                    background-color: #00BDD1;
                    transform: rotate(45deg);
                    z-index: -1;
                }
            }
        }
    }

    @media (min-width: 993px) {
        .container {
            width: 85%;
        }
    }
</style>



// WEBPACK FOOTER //
// Start.vue?1aa20286